import * as React from 'react';

const styles = require('./CCPA.scss');

interface Props {
    onVerification?: (verified: boolean) => void;
}

interface State {
    verified: null | boolean;
}

export default class CCPAVerifyResidency extends React.Component<Props, State> {
    readonly state = {
        verified: null,
    };

    constructor(props: Props) {
        super(props);
    }

    render() {
        if (this.state.verified === false) {
            return this.renderNotVeifiedView();
        }

        return this.renderDefaultView();
    }

    renderDefaultView() {
        return (
            <div className={styles.contentContainer}>
                <div className={styles.mainText}>Are you a California resident?</div>
                <div>
                    <button className='nx-button' onClick={() => this.setState({ verified: false })}>
                        No
                    </button>
                    <button
                        className='nx-button nx-button--primary'
                        onClick={() => !!this.props.onVerification && this.props.onVerification(true)}
                    >
                        Yes
                    </button>
                </div>
            </div>
        );
    }

    renderNotVeifiedView() {
        return (
            <div className={styles.contentContainer}>
                <div className={styles.mainText}>At this time, this functionality is only available to California residents.</div>
                <button
                    className='nx-button nx-button-primary'
                    onClick={() => !!this.props.onVerification && this.props.onVerification(false)}
                >
                    Ok
                </button>
            </div>
        );
    }
}
